module.exports = __webpack_public_path__ + "static/media/icon-elevator.2fc284ec.svg";